import React, { useState, useEffect } from "react";
import BuyerGTPSupport from "./GTPSupport";
import BuyerContactSupport from "./ContactSupport";
import BuyerRaisedTicket from "./RaiseTicket";
import BuyerFaq from "./Faq";
const GPSupport = () => {
    const [activeUser, setActiveUser] = useState("");
    const [activeTab, setActiveTab] = useState("Contact Support");
   const tabs = ["Contact Support","Raise Ticket"];

    
    const renderTabContent = () => {
        switch (activeTab) {
            // case "Global Partner" : return <BuyerGTPSupport />;
            case "Contact Support" : return <BuyerContactSupport />;
            case "Raise Ticket" : return <BuyerRaisedTicket />;
            // case "FAQ" : return <BuyerFaq/>;
            default:
                 return <BuyerContactSupport />;
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default GPSupport;